<template>
  <div>
    <!--  subtracted sidebar  -->
    <transition @enter="onEnter" @leave="onLeave">
      <mini-sidebar v-if="subSidebar"/>
    </transition>

    <!--  full sidebar / mobile sidebar  -->
    <transition @enter="onEnter" @leave="onLeave">
      <full-sidebar v-if="showFullSidebar"/>
    </transition>
  </div>
</template>

<script setup>
  import MiniSidebar from '@/layout/dashboard/partials/sub-sidebar.vue';
  import FullSidebar from '@/layout/dashboard/partials/full-sidebar.vue';
  import { ref, watch } from 'vue';
  import { useSidebarStore } from '@/stores/sidebar';
  import gsap from 'gsap';

  const sidebarStore = useSidebarStore();
  const subSidebar = ref(sidebarStore.showSubtractedSidebar);
  const showFullSidebar = ref(sidebarStore.showFullSidebar);

  if (window.innerWidth >= 768 && window.innerWidth <= 1440) {
    sidebarStore.updateMobileOpen(true);
  }

  watch(() => sidebarStore.showSubtractedSidebar, (value) => {
    subSidebar.value = value;
  }, { immediate: true });

  watch(() => sidebarStore.showFullSidebar, (value) => {
    showFullSidebar.value = value;
  }, { immediate: true });

  const onEnter = (el) => {
    const sidebarContent = el.querySelector('.sidebar-content');
    gsap.fromTo(sidebarContent, { x: '-100%', opacity: 0 }, { x: '0%', opacity: 1, duration: 0.2 });
  };

  const onLeave = (el, done) => {
    const sidebarContent = el.querySelector('.sidebar-content');
    gsap.to(sidebarContent, { x: '-30%', opacity: 0, duration: 0.15, onComplete: done });
  };
</script>
